
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.74.31A1 1 0 0021 0H3a1 1 0 00-.75.33 1 1 0 00-.25.76L3.31 12.8v.11L4.44 23.1a1 1 0 001 .89h13.14a1 1 0 001-.89L22 1.09a1 1 0 00-.26-.78zM17.68 22H6.33l-.91-8.28 13.32-1.36zM19 10.31L5.2 11.72 4.12 2h15.76z"}})])
          )
        }
      }
    